import { getWindowLocationValues } from './helpers'
/**
 * Track checkout step events
 *
 * @param {object} statsigClient
 * @param {object} event
 * @param {number} event.step
 * @param {object} event.scope
 */
export function trackCheckoutStepEvent(statsigClient, { step, scope }) {
  statsigClient?.logEvent('checkout_step', String(step), {
    step,
    ...getWindowLocationValues(scope),
  })
}
